import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Submenu from '../../../Partidos/Components/SubmenuFases'
import MiniCardBlue from '../MiniCardBlue'
import './_styles.scss'
import NoData from '../NoData'

class CardBlue extends Component {
    constructor (props) {
        super(props)
    }

    render () {
        const { filters, activeTab, onTabChange, onTabSelect, itemDataOptions, topTitle, rankingTop } = this.props

        return (
            <div className='estadisticas-juegos__card-blue'>
                {rankingTop && rankingTop.length > 0 ? (
                    <div className='estadisticas-juegos__card-blue-content'>
                        <div className='estadisticas-juegos__card-blue-submenu-wrap'>
                            <Submenu
                                tabs={filters}
                                activeTab={activeTab}
                                onNavigate={onTabChange}
                                classNames={{
                                    tab: 'estadisticas-juegos-cardBlue__tabs-phases',
                                    active: 'estadisticas-juegos-cardBlue__item-active-not-focused',
                                }}
                                itemDataOptions={itemDataOptions}
                            />
                        </div>

                        <div className='estadisticas-juegos__card-blue-mini-wrap'>
                            <MiniCardBlue topTitle={topTitle} rankingTop={rankingTop} />
                        </div>
                    </div>
                ) : (
                    <NoData />
                )}
            </div>
        )
    }
}

CardBlue.propTypes = {
    filters: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired
    })),
    activeTab: PropTypes.string,
    topTitle: PropTypes.string,
    onTabChange: PropTypes.func,
    onTabSelect: PropTypes.func,
    itemDataOptions: PropTypes.object
}

CardBlue.defaultProps = {
    filters: [],
    activeTab: null,
    topTitle: 'Top',
    onTabChange: null,
    onTabSelect: null,
    itemDataOptions: {}
}


export default CardBlue



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/EstadisticasJuegos/Components/CardBlue/index.jsx